// STYLES
import './_faq-item.scss'

//LIBS
import React from 'react'

// HELPERS
import * as util from '../../lib/util.js'

// INTERFACE
class FAQItem extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      expanded: false,
      target: '', 
    }
  }

  toggleExpanded  = () => {
    //Opens and closes the answer drop-downs 
    this.setState(state => ({ expanded: !state.expanded }));
  }

  captureTarget = () => {
    //On click pass the jumpLinkTarget element #id to the parent component's state
    this.props.setExpandedTarget(this.props.jumpLinkTarget);
  }

  componentDidUpdate() {
    //On mount check to see if this component has an id or expandedTarget defined, if so and they match and the answer is not already expanded, expand the answer and clear the jumpLinkTarget. If it is already expanded, then toggle the expanded state so it is ready to close on subsequent click.
    if(this.props.id === this.props.expandedTarget && this.props.id && this.props.expandedTarget){
      if(this.state.expanded === false){
        this.props.setExpandedTarget('');
        this.toggleExpanded();
      } else {
        this.toggleExpanded();
      }
    }
  }

  render () {
    //id = element #id | q = question | a = answer | jumpLinkTarget = target element #id
    const { id, q, a, jumpLinkTarget } = this.props
    
    if(id || jumpLinkTarget){
      if(id){
        //If the FAQItem has an id, add styling to allow it to be displayed correctly when navigated to from a link in another answer
        return(
          <div className="FAQItem">
            <div id={id} className="jump-target-adjustment"></div>
            <h4 style={{ cursor: 'pointer' }} onClick={() => {this.toggleExpanded()}}> {q} </h4>
            {util.renderIf(this.state.expanded,
              <div className="answer" dangerouslySetInnerHTML={{ __html: a }} />
            )}
          </div>
        )
      } else {
        //If the FAQItem has an jumpLinkTarget, update the answer content to add the anchor link. Must render the answer contents from faq/index.js separately from the anchor link and onClick. dangerouslySetInnerHTML can only handle one element and the onClick must be outside of it to function properly.
          return(
            <div className="FAQItem">
              <h4 style={{ cursor: 'pointer' }} onClick={() => {this.toggleExpanded()}}> {q} </h4>
              {util.renderIf(this.state.expanded,
                <div className="answer answer-link-left"> 
                  <p dangerouslySetInnerHTML={{ __html: a }}/>
                </div>
              )}
              {util.renderIf(this.state.expanded,
                <div className="answer answer-link-right"> 
                  <p dangerouslySetInnerHTML={{ __html: `&nbsp;<a href="#${jumpLinkTarget}">here</a>.`}} onClick={this.captureTarget}/>
                </div>
              )}
              </div>
          )
      }
    } else {
        //If the FAQItem does not have an id or jumpLinkTarget, render as normal
        return (
          <div className="FAQItem">
            <h4 style={{ cursor: 'pointer' }} onClick={() => this.toggleExpanded()}> {q} </h4>
            {util.renderIf(this.state.expanded,
              <div className="answer" dangerouslySetInnerHTML={{ __html: a }} />
            )}
          </div>
        )
    }
  }
}

export default FAQItem



// WEBPACK FOOTER //
// ./src/components/faq-item/index.js